import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { GetClientDetailsByEmployee, ManageClient, ResetClientState, SetSelectedClient, ClearClientError } from './ServiceAction';

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes orbPulse1 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.45; }
    50%     { transform: scale(1.1) translate(20px,-15px); opacity:.65; }
  }
  @keyframes orbPulse2 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.35; }
    50%     { transform: scale(1.07) translate(-20px,15px); opacity:.55; }
  }
  @keyframes cardIn {
    from { opacity:0; transform: translateY(20px) scale(.98); }
    to   { opacity:1; transform: translateY(0) scale(1); }
  }
  @keyframes particle {
    0%   { transform: translateY(0) translateX(0); opacity:0; }
    10%  { opacity:.8; }
    90%  { opacity:.3; }
    100% { transform: translateY(-110vh) translateX(var(--dx)); opacity:0; }
  }
  @keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .sm-particle {
    position: fixed;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,220,210,.8) 0%, rgba(0,160,190,.3) 60%, transparent 100%);
    animation: particle var(--dur) var(--delay) ease-in infinite;
    pointer-events: none;
    z-index: 0;
  }

  .sm-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
  }
  .sm-grid-bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.025) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }
  .sm-content {
    position: relative;
    z-index: 1;
    padding: 12px 12px 24px;
    overflow-x: auto;
  }
  .sm-breadcrumb {
    padding: 10px 16px;
    font-size: 13px;
    background: rgba(0,0,0,.25);
    border-bottom: 1px solid rgba(0,210,200,.12);
    backdrop-filter: blur(8px);
    position: sticky;
    top: 0;
    z-index: 10;
    animation: fadeSlideUp .4s ease both;
  }
  .sm-breadcrumb-link { color: #00d2c8; cursor: pointer; transition: color .2s; }
  .sm-breadcrumb-link:hover { color: #40e8e0; }
  .sm-breadcrumb-sep { margin: 0 6px; color: rgba(0,210,200,.4); }
  .sm-breadcrumb-current { color: #7ab0b8; font-weight: 600; }

  .sm-section {
    border: 1px solid rgba(0,210,200,.18);
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(12,28,45,.96) 0%, rgba(7,18,32,.98) 100%);
    box-shadow: 0 4px 24px rgba(0,0,0,.5), 0 0 40px rgba(0,150,160,.05), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .5s cubic-bezier(.16,1,.3,1) both;
    backdrop-filter: blur(12px);
  }
  .sm-shimmer-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
    animation: shimmer 3.5s linear infinite;
  }
  .sm-section-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .sm-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #e8f4f6;
    letter-spacing: .03em;
  }
  .sm-section-body {
    padding: 14px 16px;
    background: #c5d7d5;
    overflow-x: auto;
  }

  .sm-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
  }
  .sm-add-btn {
    padding: 8px 18px;
    background: rgba(0,160,155,.25);
    border: 1px solid rgba(0,210,200,.35);
    border-radius: 20px;
    color: #004a46;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'DM Sans', sans-serif;
  }
  .sm-add-btn:hover {
    background: rgba(0,160,155,.4);
    box-shadow: 0 0 12px rgba(0,160,155,.3);
  }
  .sm-add-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .sm-search-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,.52);
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 20px;
    padding: 6px 14px;
    flex: 1;
    max-width: 460px;
  }
  .sm-search-input {
    border: none;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    font-size: 12.5px;
    color: #0b2d30;
    background: transparent;
    width: 100%;
  }
  .sm-search-input::placeholder { color: rgba(10,55,58,.45); }
  
  .sm-filter-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-left: auto;
  }
  .sm-filter-select {
    padding: 6px 12px;
    background: rgba(255,255,255,.52);
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 20px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    color: #0b2d30;
    cursor: pointer;
    outline: none;
    min-width: 120px;
  }
  .sm-filter-select:focus {
    border-color: #007a74;
    box-shadow: 0 0 0 2px rgba(0,120,115,.2);
  }
  .sm-clear-filter {
    padding: 6px 12px;
    background: rgba(180,40,40,.15);
    border: 1px solid rgba(180,40,40,.3);
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    color: #7a1010;
    cursor: pointer;
    transition: all .2s;
  }
  .sm-clear-filter:hover {
    background: rgba(180,40,40,.25);
  }

  .sm-table-wrap {
    border-radius: 10px;
    overflow-x: auto;
    border: 1px solid rgba(0,110,105,.22);
  }
  .sm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    min-width: 100%;
  }
  .sm-table th {
    text-align: left;
    padding: 10px 10px;
    color: #1a5558;
    font-weight: 700;
    border-bottom: 1px solid rgba(0,110,105,.25);
    background: rgba(255,255,255,.18);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .04em;
  }
  .sm-table th.sortable { cursor: pointer; user-select: none; }
  .sm-table th.sortable:hover { background: rgba(255,255,255,.28); }
  .sm-table td {
    padding: 9px 10px;
    color: #0b2d30;
    border-bottom: 1px solid rgba(0,110,105,.1);
    vertical-align: middle;
  }
  .sm-trow { animation: fadeSlideIn 0.3s ease both; }
  .sm-trow:hover td { background: rgba(255,255,255,.18); }

  .sm-status-badge {
    border: 1.5px solid;
    border-radius: 20px;
    padding: 2px 9px;
    font-size: 11px;
    font-weight: 600;
    background: rgba(255,255,255,.35);
    display: inline-block;
    white-space: nowrap;
  }
  .sm-status-active { border-color: rgba(0,120,110,.5); color: #094a47; }
  .sm-status-inactive { border-color: rgba(180,40,40,.4); color: #7a1010; }
  .sm-status-pending { border-color: rgba(180,120,0,.5); color: #6a3c00; }
  .sm-status-completed { border-color: rgba(0,150,140,.5); color: #004a46; }

  .sm-icon-btn {
    background: rgba(255,255,255,.3);
    border: 1px solid rgba(0,110,105,.25);
    border-radius: 6px;
    padding: 5px 7px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    color: #1a5558;
    transition: all .15s;
    font-family: inherit;
    font-size: 12px;
  }
  .sm-icon-btn:hover { background: rgba(255,255,255,.5); }
  .sm-icon-btn.del:hover { background: rgba(180,40,40,.15); color: #7a1010; border-color: rgba(180,40,40,.3); }
  .sm-icon-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .sm-sort-icon {
    background: rgba(0,110,105,.2);
    border-radius: 3px;
    padding: 0px 4px;
    font-size: 10px;
    color: #1a5558;
    margin-left: 4px;
  }

  .sm-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    font-size: 12px;
    color: #2a7070;
    font-weight: 600;
    flex-wrap: wrap;
  }
  .sm-pg-select {
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 6px;
    padding: 3px 7px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    color: #094a47;
    background: rgba(255,255,255,.4);
    cursor: pointer;
    outline: none;
  }
  .sm-action-btn {
    padding: 4px 10px;
    background: rgba(0,110,105,.15);
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 20px;
    color: #094a47;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    font-family: 'DM Sans', sans-serif;
  }
  .sm-action-btn:hover { background: rgba(0,110,105,.26); }
  .sm-action-btn:disabled { opacity: .4; cursor: default; }

  .sm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(4,17,26,.65);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  /* FIXED MODAL STYLES - Header and Footer properly positioned */
  .sm-modal {
    background: linear-gradient(160deg, #0c1c2d 0%, #071220 100%);
    border: 1px solid rgba(0,210,200,.2);
    border-radius: 14px;
    width: 600px;
    max-width: 85vw;
    height: 85vh;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0,0,0,.6), 0 0 40px rgba(0,150,160,.08);
  }
  
  .sm-modal-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 14px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    z-index: 10;
  }
  
  .sm-modal-title { 
    color: #e8f4f6; 
    font-size: 14px; 
    font-weight: 700; 
  }
  
  .sm-modal-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: #c5d7d5;
    flex: 1;
    overflow-y: auto;
  }
  
  .sm-modal-footer {
    padding: 14px 20px;
    border-top: 1px solid rgba(0,110,105,.2);
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    background: rgba(0,0,0,.3);
    flex-shrink: 0;
    backdrop-filter: blur(10px);
  }
  
  /* Custom scrollbar for modal body */
  .sm-modal-body::-webkit-scrollbar {
    width: 6px;
  }
  
  .sm-modal-body::-webkit-scrollbar-track {
    background: rgba(0,0,0,.1);
    border-radius: 3px;
  }
  
  .sm-modal-body::-webkit-scrollbar-thumb {
    background: rgba(0,210,200,.3);
    border-radius: 3px;
  }
  
  .sm-modal-body::-webkit-scrollbar-thumb:hover {
    background: rgba(0,210,200,.5);
  }
  
  .sm-form-row { display: flex; flex-direction: column; gap: 5px; }
  .sm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .sm-label {
    font-size: 10.5px;
    color: #1a5558;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
  }
  .sm-input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 7px;
    font-size: 12px;
    height: 30px;
    box-sizing: border-box;
    background: rgba(255,255,255,.52);
    color: #0b2d30;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    transition: border-color .2s, box-shadow .2s;
    outline: none;
  }
  .sm-input:focus {
    border-color: #007a74;
    box-shadow: 0 0 0 3px rgba(0,120,115,.2);
    background: rgba(255,255,255,.72);
  }
  textarea.sm-input { height: 72px; resize: vertical; padding-top: 8px; }
  select.sm-input { cursor: pointer; }
  .sm-cancel-btn {
    padding: 8px 18px;
    background: rgba(255,255,255,.12);
    border: 1px solid rgba(255,255,255,.2);
    border-radius: 7px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #7ab0b8;
    cursor: pointer;
    transition: all .2s;
  }
  .sm-cancel-btn:hover { background: rgba(255,255,255,.2); }
  .sm-save-btn {
    padding: 8px 20px;
    background: rgba(0,160,155,.3);
    border: 1px solid rgba(0,210,200,.4);
    border-radius: 7px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #004a46;
    cursor: pointer;
    transition: all .2s;
  }
  .sm-save-btn:hover { background: rgba(0,160,155,.45); box-shadow: 0 0 12px rgba(0,160,155,.3); }
  .sm-save-btn:disabled { opacity: .5; cursor: not-allowed; }
  
  .sm-badge {
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 600;
    display: inline-block;
    white-space: nowrap;
  }
  .sm-badge-success { background: rgba(0,150,140,.2); color: #004a46; }
  .sm-badge-warning { background: rgba(180,120,0,.2); color: #6a3c00; }
  .sm-badge-info { background: rgba(0,120,175,.2); color: #005e8a; }
  .sm-badge-danger { background: rgba(180,40,40,.2); color: #7a1010; }
  
  .sm-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    font-size: 14px;
    color: #1a5558;
  }
  
  .sm-error {
    background: rgba(180,40,40,.15);
    border: 1px solid rgba(180,40,40,.3);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    color: #7a1010;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .sm-success {
    background: rgba(0,150,140,.15);
    border: 1px solid rgba(0,150,140,.3);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    color: #004a46;
    font-size: 13px;
  }

  @media (max-width: 1200px) {
    .sm-table th, .sm-table td {
      padding: 6px 8px;
    }
    .sm-table {
      font-size: 11px;
    }
  }
`;

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 4 + 2,
  left: Math.random() * 100,
  dur: Math.random() * 12 + 8,
  delay: Math.random() * 10,
  dx: (Math.random() - 0.5) * 100,
}));

const COURSES = ['MBA', 'BBA', 'B.Tech', 'M.Tech', 'MBBS', 'BDS', 'LLB', 'B.Sc', 'M.Sc', 'BCA', 'MCA', 'B.Com', 'M.Com', 'BArch'];

// Define the ClientRecord type that matches exactly with your Redux state/actions
interface ClientRecord {
  client_id: number;
  client_name: string;
  client_phone: string;
  client_email: string;
  client_status: 'active' | 'inactive' | 'pending';
  quotation: number;
  assignment: string;
  exact_requirement_notes: string;
  assignment_timeline: string;
  assignment_status: 'not_started' | 'in_progress' | 'completed' | 'on_hold';
  payment_information: string;
  payment_timeline: string;
  review: string;
  client_address: string;
  employee_code: string;
  updatedby: string;
  created_at: string;
  updated_at: string;
  cources: string | null;
  caller: string | null;
  counsellor: string | null;
  follow_up: string | null;
  payment_mode: string | null;
  payment_account: string | null;
}

const EMPTY_FORM = {
  clientName: '',
  clientPhone: '',
  clientEmail: '',
  clientStatus: 'pending' as 'active' | 'inactive' | 'pending',
  quotation: 0,
  assignment: '',
  exactRequirementNotes: '',
  assignmentTimeline: '',
  assignmentStatus: 'not_started' as 'not_started' | 'in_progress' | 'completed' | 'on_hold',
  paymentInformation: '',
  paymentTimeline: '',
  review: '',
  clientAddress: '',
  changedBy: '',
  employeeCode: '',
  cources: '',
  caller: '',
  counsellor: '',
  followUp: '',
  payment_mode: '',
  payment_account: ''
};

interface Props {
  clients: ClientRecord[];
  emplopyelist: any[];
  loading: boolean;
  error: any;
  message: string;
  operationStatus: any;
  GetClientDetailsByEmployee: (employeeCode: string) => Promise<any>;
  ManageClient: (clientData: any) => Promise<any>;
  ResetClientState: () => void;
  SetSelectedClient: (client: ClientRecord | null) => void;
  ClearClientError: () => void;
}

interface State {
  employeeCode: string;
  search: string;
  page: number;
  rowsPerPage: number;
  sortAsc: boolean;
  sortBy: string;
  showModal: boolean;
  editingClient: ClientRecord | null;
  form: typeof EMPTY_FORM;
  submitting: boolean;
  notification: { type: 'success' | 'error'; message: string } | null;
  filterCourse: string;
  filterStatus: string;
  roleCode: string | null;
}

class ClientManagementPage extends PureComponent<Props, State> {
  state: State = {
    employeeCode: '',
    search: '',
    page: 0,
    rowsPerPage: 10,
    sortAsc: true,
    sortBy: 'client_name',
    showModal: false,
    editingClient: null,
    form: { ...EMPTY_FORM },
    submitting: false,
    notification: null,
    filterCourse: 'All',
    filterStatus: 'All',
    roleCode: null,
  };
  componentDidMount() {
    const employeeCode = sessionStorage.getItem('employeeCode') || '';
    const roleCode = sessionStorage.getItem('RoleCode') || '';

    console.log('Employee code from sessionStorage:', employeeCode);
    console.log('Role code from sessionStorage:', roleCode);

    // Set roleCode in state immediately
    this.setState({ employeeCode, roleCode });

    this.props.GetClientDetailsByEmployee(employeeCode);
  }


  componentWillUnmount() {
    this.props.ResetClientState();
  }

  // Helper function to show notification
  showNotification = (type: 'success' | 'error', message: string) => {
    this.setState({ notification: { type, message } });
    setTimeout(() => {
      this.setState({ notification: null });
    }, 5000);
  };

  // Check if user has permission to edit/delete
  // Check if user has permission to edit/delete
  hasEditDeletePermission = (): boolean => {
    const { roleCode } = this.state;
    // Check both state and sessionStorage
    const currentRole = roleCode || sessionStorage.getItem('RoleCode');
    return currentRole === 'ADMIN' || currentRole === 'FONT_OFFICE';
  };

  // Check if user has permission to add new clients
  hasAddPermission = (): boolean => {
    const { roleCode } = this.state;
    // Check both state and sessionStorage
    const currentRole = roleCode || sessionStorage.getItem('RoleCode');
    return currentRole === 'ADMIN' || currentRole === 'FONT_OFFICE';
  };
  get filteredClients() {
    const { clients } = this.props;
    const { search, sortBy, sortAsc, filterCourse, filterStatus } = this.state;

    let filtered = [...clients];

    // Apply search filter
    if (search) {
      const q = search.toLowerCase();
      filtered = filtered.filter(c =>
        c.client_name?.toLowerCase().includes(q) ||
        c.client_email?.toLowerCase().includes(q) ||
        c.client_phone?.includes(q) ||
        c.assignment?.toLowerCase().includes(q) ||
        c.client_address?.toLowerCase().includes(q) ||
        (c.cources && c.cources.toLowerCase().includes(q)) ||
        (c.caller && c.caller.toLowerCase().includes(q)) ||
        (c.counsellor && c.counsellor.toLowerCase().includes(q)) ||
        (c.follow_up && c.follow_up.toLowerCase().includes(q))
      );
    }

    // Apply course filter
    if (filterCourse && filterCourse !== 'All') {
      filtered = filtered.filter(c => c.cources === filterCourse);
    }

    // Apply status filter (client status)
    if (filterStatus && filterStatus !== 'All') {
      filtered = filtered.filter(c => c.client_status === filterStatus);
    }

    // Apply sorting
    filtered.sort((a, b) => {
      let aVal = a[sortBy as keyof ClientRecord];
      let bVal = b[sortBy as keyof ClientRecord];

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return sortAsc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      }
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return sortAsc ? aVal - bVal : bVal - aVal;
      }
      return 0;
    });

    return filtered;
  }

  get paginatedClients() {
    const { page, rowsPerPage } = this.state;
    const filtered = this.filteredClients;
    return filtered.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  }

  // Clear all filters
  clearFilters = () => {
    this.setState({
      search: '',
      filterCourse: 'All',
      filterStatus: 'All',
      page: 0
    });
  };

  openAdd = () => {
    const { employeeCode } = this.state;
    this.setState({
      showModal: true,
      editingClient: null,
      form: {
        ...EMPTY_FORM,
        employeeCode: employeeCode,
        changedBy: employeeCode
      },
      submitting: false
    });
  };

  openEdit = (client: ClientRecord) => {
    const { employeeCode } = this.state;
    console.log('=== EDITING CLIENT ===');
    console.log('Client object:', client);
    console.log('Client ID:', client.client_id);
    console.log('Client follow_up:', client.follow_up);

    this.setState({
      showModal: true,
      editingClient: client,
      form: {
        clientName: client.client_name,
        clientPhone: client.client_phone,
        clientEmail: client.client_email,
        clientStatus: client.client_status,
        quotation: client.quotation,
        assignment: client.assignment,
        exactRequirementNotes: client.exact_requirement_notes,
        assignmentTimeline: client.assignment_timeline,
        assignmentStatus: client.assignment_status,
        paymentInformation: client.payment_information,
        paymentTimeline: client.payment_timeline,
        review: client.review,
        clientAddress: client.client_address,
        changedBy: employeeCode,
        employeeCode: employeeCode,
        cources: client.cources || '',
        caller: client.caller || '',
        counsellor: client.counsellor || '',
        followUp: client.follow_up || '',
        payment_mode: client.payment_mode || '',
        payment_account: client.payment_account || '',
      },
      submitting: false
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      submitting: false,
      editingClient: null,
      form: { ...EMPTY_FORM }
    });
    this.props.ClearClientError();
  };

  handleFormChange = (field: keyof typeof EMPTY_FORM, value: string | number) => {
    this.setState(prev => ({ form: { ...prev.form, [field]: value } }));
  };

  handleSave = async () => {
    const { editingClient, form, employeeCode } = this.state;
    const { ManageClient, ClearClientError } = this.props;

    // Validate required fields
    if (!form.clientName || !form.clientName.trim()) {
      this.showNotification('error', 'Client name is required');
      return;
    }

    if (!form.clientPhone || !form.clientPhone.trim()) {
      this.showNotification('error', 'Client phone is required');
      return;
    }

    if (!form.clientEmail || !form.clientEmail.trim()) {
      this.showNotification('error', 'Client email is required');
      return;
    }

    this.setState({ submitting: true });

    const payload = {
      indicator: editingClient ? 'U' : 'I',
      id: editingClient ? editingClient.client_id : 0,
      clientName: form.clientName,
      clientPhone: form.clientPhone,
      clientEmail: form.clientEmail,
      clientStatus: form.clientStatus,
      quotation: form.quotation ? form.quotation.toString() : "0",
      assignment: form.assignment || "",
      exactRequirementNotes: form.exactRequirementNotes || "",
      assignmentTimeline: form.assignmentTimeline || "",
      assignmentStatus: form.assignmentStatus,
      paymentInformation: form.paymentInformation || "",
      paymentTimeline: form.paymentTimeline || "",
      review: form.review || "",
      clientAddress: form.clientAddress || "",
      cources: form.cources || "",
      caller: form.caller || "",
      counsellor: form.counsellor || "",
      followUp: form.followUp || "",
      employeeCode: form.employeeCode || employeeCode,
      paymentMode: form.payment_mode || '',
      paymentAccount: form.payment_account || '',
      updatedBy: form.changedBy || employeeCode,
      createdAt: editingClient?.created_at || null,
      updatedAt: new Date().toISOString()
    };

    console.log('=== SAVING CLIENT ===');
    console.log('Edit mode:', editingClient ? `YES - indicator: U, id: ${editingClient.client_id}` : 'NO - indicator: I');
    console.log('Payload being sent:', payload);

    try {
      const response = await ManageClient(payload);
      console.log('ManageClient response:', response);

      if (response && response.success === true) {
        const operationType = editingClient ? 'updated' : 'added';
        this.showNotification('success', `Client ${operationType} successfully!`);
        ClearClientError();

        this.setState({
          showModal: false,
          submitting: false,
          editingClient: null,
          form: { ...EMPTY_FORM }
        });
      } else {
        console.error('Operation failed:', response);
        const errorMessage = response?.message || 'Failed to save client';
        this.showNotification('error', errorMessage);
        this.setState({ submitting: false });
      }
    } catch (error: any) {
      console.error('Error saving client:', error);
      const errorMessage = error?.message || error?.response?.data?.message || 'An error occurred while saving client';
      this.showNotification('error', errorMessage);
      this.setState({ submitting: false });
    }
  };

  handleDelete = async (client: ClientRecord) => {
    if (window.confirm(`Are you sure you want to delete client: ${client.client_name}?`)) {
      const { employeeCode } = this.state;
      const { ManageClient, ClearClientError } = this.props;

      const payload = {
        indicator: 'D',
        id: client.client_id,
        clientName: client.client_name || "",
        clientPhone: client.client_phone || "",
        clientEmail: client.client_email || "",
        clientStatus: client.client_status || "pending",
        quotation: client.quotation ? client.quotation.toString() : "0",
        assignment: client.assignment || "",
        exactRequirementNotes: client.exact_requirement_notes || "",
        assignmentTimeline: client.assignment_timeline || "",
        assignmentStatus: client.assignment_status || "not_started",
        paymentInformation: client.payment_information || "",
        paymentTimeline: client.payment_timeline || "",
        review: client.review || "",
        clientAddress: client.client_address || "",
        cources: client.cources || "",
        caller: client.caller || "",
        counsellor: client.counsellor || "",
        followUp: client.follow_up || "",
        employeeCode: employeeCode,
        paymentMode: client.payment_mode || '',
        paymentAccount: client.payment_account || '',
        updatedBy: employeeCode,
        createdAt: client.created_at || null,
        updatedAt: new Date().toISOString()
      };

      console.log('Delete client payload:', payload);

      try {
        const response = await ManageClient(payload);
        console.log('Delete response:', response);

        if (response && response.success === true) {
          this.showNotification('success', `Client "${client.client_name}" deleted successfully!`);
          ClearClientError();
        } else {
          console.error('Delete operation failed:', response);
          const errorMessage = response?.message || 'Failed to delete client';
          this.showNotification('error', errorMessage);
        }
      } catch (error: any) {
        console.error('Error deleting client:', error);
        const errorMessage = error?.message || error?.response?.data?.message || 'An error occurred while deleting client';
        this.showNotification('error', errorMessage);
      }
    }
  };

  handleSort = (field: string) => {
    this.setState(prev => ({
      sortBy: field,
      sortAsc: prev.sortBy === field ? !prev.sortAsc : true,
      page: 0
    }));
  };

  getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'active': return 'sm-status-active';
      case 'inactive': return 'sm-status-inactive';
      case 'pending': return 'sm-status-pending';
      case 'not_started': return 'sm-badge-info';
      case 'in_progress': return 'sm-badge-warning';
      case 'completed': return 'sm-badge-success';
      case 'on_hold': return 'sm-badge-danger';
      default: return '';
    }
  };

  getAssignmentStatusDisplay = (status: string) => {
    switch (status) {
      case 'not_started': return 'Not Started';
      case 'in_progress': return 'In Progress';
      case 'completed': return 'Completed';
      case 'on_hold': return 'On Hold';
      default: return status;
    }
  };

  render() {
    const { clients, loading, error, message, emplopyelist } = this.props;
    const {
      search, page, rowsPerPage, sortAsc, sortBy, showModal, editingClient,
      form, submitting, employeeCode, notification, filterCourse, filterStatus, roleCode
    } = this.state;

    const filtered = this.filteredClients;
    const paginated = this.paginatedClients;
    const totalPages = Math.ceil(filtered.length / rowsPerPage);
    const start = page * rowsPerPage + 1;
    const end = Math.min((page + 1) * rowsPerPage, filtered.length);

    // Get unique courses from clients for filter dropdown
    const coursesList = clients
      .map(c => c.cources)
      .filter((course): course is string => course !== null && course !== undefined);
    const uniqueCourses = ['All', ...Array.from(new Set(coursesList))];

    const hasEditDeletePerm = this.hasEditDeletePermission();
    const hasAddPerm = this.hasAddPermission();

    // Prepare employee list for dropdowns (remove duplicates by employeeCode)
    const employeeList = emplopyelist && emplopyelist.length > 0
      ? emplopyelist.reduce((unique: any[], emp: any) => {
        if (!unique.find(e => e.employeeCode === emp.employeeCode)) {
          unique.push(emp);
        }
        return unique;
      }, [])
      : [];

    return (
      <>
        <style>{globalStyles}</style>
        <div className="sm-page">
          <div style={{ position: 'fixed', top: '5%', left: '8%', width: 420, height: 420, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,160,155,.2) 0%, transparent 68%)', animation: 'orbPulse1 11s ease-in-out infinite', pointerEvents: 'none', zIndex: 0 }} />
          <div style={{ position: 'fixed', bottom: '8%', right: '6%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,120,175,.15) 0%, transparent 68%)', animation: 'orbPulse2 15s ease-in-out infinite', pointerEvents: 'none', zIndex: 0 }} />
          <div className="sm-grid-bg" />
          {PARTICLES.map(p => (
            <div key={p.id} className="sm-particle" style={{ width: p.size, height: p.size, left: `${p.left}%`, bottom: -p.size, ['--dur' as any]: `${p.dur}s`, ['--delay' as any]: `${p.delay}s`, ['--dx' as any]: `${p.dx}px` }} />
          ))}

          <div className="sm-breadcrumb">
            <span className="sm-breadcrumb-link">Dashboard</span>
            <span className="sm-breadcrumb-sep">/</span>
            <span className="sm-breadcrumb-current">Client Management</span>
            {roleCode && (
              <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#00d2c8' }}>
                Role: {roleCode === 'ADMIN' ? '👑 Administrator' : roleCode === 'FONT_OFFICE' ? '📞 Front Office' : roleCode}
              </span>
            )}
          </div>

          <div className="sm-content">
            <div className="sm-section">
              <div className="sm-shimmer-line" />
              <div className="sm-section-header">
                <span className="sm-section-title">Client Management Dashboard</span>
                {emplopyelist && emplopyelist.length > 0 && (
                  <span style={{ fontSize: '11px', color: '#7ab0b8' }}>
                    Employee: {emplopyelist[0]?.employeeName || ''} ({employeeCode})
                  </span>
                )}
              </div>

              <div className="sm-section-body">
                {/* Custom Notification */}
                {notification && (
                  <div className={notification.type === 'success' ? 'sm-success' : 'sm-error'}>
                    {notification.type === 'success' ? '✓' : '❌'} {notification.message}
                  </div>
                )}

                {error && (
                  <div className="sm-error">
                    <span>❌ {typeof error === 'string' ? error : error.message || 'An error occurred'}</span>
                    <button className="sm-icon-btn" onClick={() => this.props.ClearClientError()}>Dismiss</button>
                  </div>
                )}

                {message && !error && !notification && (
                  <div className="sm-success">
                    ✓ {message}
                  </div>
                )}

                <div className="sm-toolbar">
                  {hasAddPerm && (
                    <button className="sm-add-btn" onClick={this.openAdd}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14" /></svg>
                      Add Client
                    </button>
                  )}
                  {!hasAddPerm && (
                    <div className="sm-add-btn" style={{ opacity: 0.5, cursor: 'not-allowed' }} title="Read-only mode">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                      View Only
                    </div>
                  )}
                  <div className="sm-search-wrap">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2a7070" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
                    <input
                      className="sm-search-input"
                      placeholder="Search clients by name, email, phone, assignment, caller, counsellor, follow up..."
                      value={search}
                      onChange={e => this.setState({ search: e.target.value, page: 0 })}
                    />
                  </div>
                  <div className="sm-filter-group">
                    <select
                      className="sm-filter-select"
                      value={filterCourse}
                      onChange={e => this.setState({ filterCourse: e.target.value, page: 0 })}
                    >
                      {uniqueCourses.map(course => (
                        <option key={course} value={course}>{course === 'All' ? 'All Courses' : course}</option>
                      ))}
                    </select>
                    <select
                      className="sm-filter-select"
                      value={filterStatus}
                      onChange={e => this.setState({ filterStatus: e.target.value, page: 0 })}
                    >
                      <option value="All">All Status</option>
                      <option value="active">Active</option>
                      <option value="pending">Pending</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    {(filterCourse !== 'All' || filterStatus !== 'All' || search) && (
                      <button className="sm-clear-filter" onClick={this.clearFilters}>
                        Clear Filters
                      </button>
                    )}
                  </div>
                </div>

                {loading ? (
                  <div className="sm-loading">
                    <div>Loading clients...</div>
                  </div>
                ) : (
                  <>
                    <div className="sm-table-wrap">
                      <table className="sm-table">
                        <thead>
                          <tr>
                            <th style={{ width: 70 }}>Actions</th>
                            <th className="sortable" onClick={() => this.handleSort('client_name')}>
                              Client Name {sortBy === 'client_name' && <span className="sm-sort-icon">{sortAsc ? '↑' : '↓'}</span>}
                            </th>
                            <th className="sortable" onClick={() => this.handleSort('client_phone')}>
                              Phone {sortBy === 'client_phone' && <span className="sm-sort-icon">{sortAsc ? '↑' : '↓'}</span>}
                            </th>
                            <th>Email</th>
                            <th className="sortable" onClick={() => this.handleSort('client_status')}>
                              Status {sortBy === 'client_status' && <span className="sm-sort-icon">{sortAsc ? '↑' : '↓'}</span>}
                            </th>
                            <th className="sortable" onClick={() => this.handleSort('quotation')}>
                              Quotation {sortBy === 'quotation' && <span className="sm-sort-icon">{sortAsc ? '↑' : '↓'}</span>}
                            </th>
                            <th>Course</th>
                            <th>Assignment</th>
                            <th>Requirements</th>
                            <th>Timeline</th>
                            <th className="sortable" onClick={() => this.handleSort('assignment_status')}>
                              Assignment Status {sortBy === 'assignment_status' && <span className="sm-sort-icon">{sortAsc ? '↑' : '↓'}</span>}
                            </th>
                            <th>Payment Info</th>
                            <th>Payment Timeline</th>
                            <th>Review</th>
                            <th>Address</th>
                            <th>Caller</th>
                            <th>Counsellor</th>
                            <th>Follow Up With</th>
                            <th>Payment Mode</th>
                            <th>Payment Account</th>
                            <th>Updated By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginated.length === 0 ? (
                            <tr>
                              <td colSpan={21} style={{ textAlign: 'center', padding: '40px' }}>
                                No clients found
                              </td>
                            </tr>
                          ) : (
                            paginated.map((c, i) => (
                              <tr key={c.client_id} className="sm-trow" style={{ animationDelay: `${i * 40}ms` }}>
                                <td style={{ width: 70 }}>
                                  <div style={{ display: 'flex', gap: 5 }}>
                                    {hasEditDeletePerm && (
                                      <>
                                        <button className="sm-icon-btn" onClick={() => this.openEdit(c)} title="Edit">
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                                        </button>
                                        <button className="sm-icon-btn del" onClick={() => this.handleDelete(c)} title="Delete">
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" /></svg>
                                        </button>
                                      </>
                                    )}
                                    {!hasEditDeletePerm && (
                                      <span style={{ fontSize: '11px', color: '#7ab0b8' }} title="Read-only">
                                        👁️ View
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td style={{ fontWeight: 600, color: '#0b2d30' }}>{c.client_name}</td>
                                <td>{c.client_phone}</td>
                                <td style={{ fontSize: 11 }}>{c.client_email}</td>
                                <td>
                                  <span className={`sm-status-badge ${this.getStatusBadgeClass(c.client_status)}`}>
                                    {c.client_status}
                                  </span>
                                </td>
                                <td style={{ fontWeight: 600, color: '#005e5a' }}>${c.quotation?.toLocaleString()}</td>
                                <td style={{ fontWeight: 500 }}>{c.cources || '-'}</td>
                                <td style={{ fontWeight: 500 }}>{c.assignment}</td>
                                <td style={{ maxWidth: 200, fontSize: 11 }}>{c.exact_requirement_notes}</td>
                                <td style={{ fontSize: 11 }}>{c.assignment_timeline}</td>
                                <td>
                                  <span className={`sm-badge ${this.getStatusBadgeClass(c.assignment_status)}`}>
                                    {this.getAssignmentStatusDisplay(c.assignment_status)}
                                  </span>
                                </td>
                                <td style={{ maxWidth: 150, fontSize: 11 }}>{c.payment_information}</td>
                                <td style={{ maxWidth: 150, fontSize: 11 }}>{c.payment_timeline}</td>
                                <td style={{ maxWidth: 150, fontSize: 11 }}>{c.review}</td>
                                <td style={{ maxWidth: 150, fontSize: 11 }}>{c.client_address}</td>
                                <td style={{ fontSize: 11 }}>{c.caller || '-'}</td>
                                <td style={{ fontSize: 11 }}>{c.counsellor || '-'}</td>
                                <td style={{ fontSize: 11 }}>{c.follow_up || '-'}</td>
                                <td style={{ fontSize: 11 }}>{c.payment_mode || '-'}</td>
                                <td style={{ fontSize: 11 }}>{c.payment_account || '-'}</td>
                                <td style={{ fontSize: 10 }}>{c.updatedby}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {filtered.length > 0 && (
                      <div className="sm-pagination">
                        <span style={{ fontSize: 11, marginRight: 4 }}>
                          Showing {start}–{end} of {filtered.length}
                        </span>
                        <span>Rows per page:</span>
                        <select
                          className="sm-pg-select"
                          value={rowsPerPage}
                          onChange={e => this.setState({ rowsPerPage: Number(e.target.value), page: 0 })}
                        >
                          {[5, 10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                        </select>
                        <button className="sm-action-btn" disabled={page === 0} onClick={() => this.setState(p => ({ page: p.page - 1 }))}>◀</button>
                        {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => (
                          <button
                            key={i}
                            className="sm-action-btn"
                            style={{ background: page === i ? 'rgba(0,110,105,.28)' : undefined, fontWeight: page === i ? 700 : 600 }}
                            onClick={() => this.setState({ page: i })}
                          >
                            {i + 1}
                          </button>
                        ))}
                        <button className="sm-action-btn" disabled={page >= totalPages - 1} onClick={() => this.setState(p => ({ page: p.page + 1 }))}>▶</button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* FIXED MODAL - With proper header and footer positioning */}
          {showModal && hasAddPerm && (
            <div className="sm-overlay" onClick={this.closeModal}>
              <div className="sm-modal" onClick={e => e.stopPropagation()}>
                <div className="sm-shimmer-line" />
                <div className="sm-modal-header">
                  <span className="sm-modal-title">{editingClient ? '✏️ Edit Client' : '➕ Add New Client'}</span>
                  <button
                    className="sm-icon-btn"
                    onClick={this.closeModal}
                    style={{ background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.15)', color: '#7ab0b8' }}
                    disabled={submitting}
                  >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12" /></svg>
                  </button>
                </div>
                <div className="sm-modal-body">
                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Client Name *</label>
                      <input
                        className="sm-input"
                        value={form.clientName}
                        onChange={e => this.handleFormChange('clientName', e.target.value)}
                        placeholder="Full name"
                        disabled={submitting}
                      />
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Client Phone *</label>
                      <input
                        className="sm-input"
                        value={form.clientPhone}
                        onChange={e => this.handleFormChange('clientPhone', e.target.value)}
                        placeholder="Phone number"
                        disabled={submitting}
                      />
                    </div>
                  </div>

                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Client Email *</label>
                      <input
                        className="sm-input"
                        type="email"
                        value={form.clientEmail}
                        onChange={e => this.handleFormChange('clientEmail', e.target.value)}
                        placeholder="Email address"
                        disabled={submitting}
                      />
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Client Status</label>
                      <select
                        className="sm-input"
                        value={form.clientStatus}
                        onChange={e => this.handleFormChange('clientStatus', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="active">Active</option>
                        <option value="pending">Pending</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Quotation ($)</label>
                      <input
                        className="sm-input"
                        type="number"
                        value={form.quotation}
                        onChange={e => this.handleFormChange('quotation', Number(e.target.value))}
                        disabled={submitting}
                      />
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Course</label>
                      <select
                        className="sm-input"
                        value={form.cources}
                        onChange={e => this.handleFormChange('cources', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Course</option>
                        {COURSES.map(course => (
                          <option key={course} value={course}>{course}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="sm-form-row">
                    <label className="sm-label">Assignment</label>
                    <input
                      className="sm-input"
                      value={form.assignment}
                      onChange={e => this.handleFormChange('assignment', e.target.value)}
                      placeholder="Assignment name"
                      disabled={submitting}
                    />
                  </div>

                  <div className="sm-form-row">
                    <label className="sm-label">Exact Requirement Notes</label>
                    <textarea
                      className="sm-input"
                      value={form.exactRequirementNotes}
                      onChange={e => this.handleFormChange('exactRequirementNotes', e.target.value)}
                      placeholder="Detailed requirements..."
                      rows={2}
                      disabled={submitting}
                    />
                  </div>

                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Assignment Timeline</label>
                      <input
                        className="sm-input"
                        value={form.assignmentTimeline}
                        onChange={e => this.handleFormChange('assignmentTimeline', e.target.value)}
                        placeholder="e.g., Start date to End date"
                        disabled={submitting}
                      />
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Assignment Status</label>
                      <select
                        className="sm-input"
                        value={form.assignmentStatus}
                        onChange={e => this.handleFormChange('assignmentStatus', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="not_started">Not Started</option>
                        <option value="in_progress">In Progress</option>
                        <option value="on_hold">On Hold</option>
                        <option value="completed">Completed</option>
                      </select>
                    </div>
                  </div>

                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Payment Information</label>
                      <input
                        className="sm-input"
                        value={form.paymentInformation}
                        onChange={e => this.handleFormChange('paymentInformation', e.target.value)}
                        placeholder="Payment method & terms"
                        disabled={submitting}
                      />
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Payment Timeline</label>
                      <input
                        className="sm-input"
                        value={form.paymentTimeline}
                        onChange={e => this.handleFormChange('paymentTimeline', e.target.value)}
                        placeholder="Payment schedule"
                        disabled={submitting}
                      />
                    </div>
                  </div>

                  {/* NEW: Payment Mode and Payment Account dropdowns */}
                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Payment Mode</label>
                      <select
                        className="sm-input"
                        value={form.payment_mode}
                        onChange={e => this.handleFormChange('payment_mode', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Payment Mode</option>
                        <option value="Cash">Cash</option>
                        <option value="CHEQUE">CHEQUE</option>
                        <option value="NEFT">NEFT</option>
                        <option value="ONLINE">ONLINE</option>
                        <option value="UPI">UPI</option>
                        <option value="CREDIT CARD">CREDIT CARD</option>
                      </select>
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Payment Account</label>
                      <select
                        className="sm-input"
                        value={form.payment_account}
                        onChange={e => this.handleFormChange('payment_account', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Payment Account</option>
                        <option value="MCS FEDERAL">MCS FEDERAL</option>
                        <option value="MCS HDFC">MCS HDFC</option>
                        <option value="EDVISOR & COMPANY">EDVISOR & COMPANY</option>
                        <option value="ADHERENCE & EDVISOR EDUCATION MANAGEMENT SERVICE PVT LTD">ADHERENCE & EDVISOR EDUCATION MANAGEMENT SERVICE PVT LTD</option>
                        <option value="SUMAN PERSONAL">SUMAN PERSONAL</option>
                        <option value="TANVEER SIR PERSONAL">TANVEER SIR PERSONAL</option>
                      </select>
                    </div>
                  </div>

                  {/* Caller, Counsellor, and Follow Up Dropdowns */}
                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Caller</label>
                      <select
                        className="sm-input"
                        value={form.caller}
                        onChange={e => this.handleFormChange('caller', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Caller</option>
                        {employeeList.map((emp: any) => (
                          <option key={emp.employeeCode} value={emp.employeeName || emp.employeeCode}>
                            {emp.employeeName} ({emp.employeeCode})
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="sm-form-row">
                      <label className="sm-label">Counsellor</label>
                      <select
                        className="sm-input"
                        value={form.counsellor}
                        onChange={e => this.handleFormChange('counsellor', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Counsellor</option>
                        {employeeList.map((emp: any) => (
                          <option key={emp.employeeCode} value={emp.employeeName || emp.employeeCode}>
                            {emp.employeeName} ({emp.employeeCode})
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Follow Up Dropdown */}
                  <div className="sm-form-grid">
                    <div className="sm-form-row">
                      <label className="sm-label">Follow Up With</label>
                      <select
                        className="sm-input"
                        value={form.followUp}
                        onChange={e => this.handleFormChange('followUp', e.target.value)}
                        disabled={submitting}
                      >
                        <option value="">Select Follow Up Person</option>
                        {employeeList.map((emp: any) => (
                          <option key={emp.employeeCode} value={emp.employeeName || emp.employeeCode}>
                            {emp.employeeName} ({emp.employeeCode})
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="sm-form-row">
                    <label className="sm-label">Review (After Complete)</label>
                    <textarea
                      className="sm-input"
                      value={form.review}
                      onChange={e => this.handleFormChange('review', e.target.value)}
                      placeholder="Project review and feedback..."
                      rows={2}
                      disabled={submitting}
                    />
                  </div>

                  <div className="sm-form-row">
                    <label className="sm-label">Client Address</label>
                    <textarea
                      className="sm-input"
                      value={form.clientAddress}
                      onChange={e => this.handleFormChange('clientAddress', e.target.value)}
                      placeholder="Full address"
                      rows={2}
                      disabled={submitting}
                    />
                  </div>
                </div>
                <div className="sm-modal-footer">
                  <button
                    className="sm-cancel-btn"
                    onClick={this.closeModal}
                    disabled={submitting}
                  >
                    Cancel
                  </button>
                  <button
                    className="sm-save-btn"
                    onClick={this.handleSave}
                    disabled={submitting}
                  >
                    {submitting ? 'Saving...' : (editingClient ? 'Save Changes' : 'Add Client')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  clients: state.client.clients || [],
  emplopyelist: state.client.emplopyelist || [],
  loading: state.client.loading || false,
  error: state.client.error,
  message: state.client.message,
  operationStatus: state.client.operationStatus
});

const mapDispatchToProps = {
  GetClientDetailsByEmployee,
  ManageClient,
  ResetClientState,
  SetSelectedClient,
  ClearClientError
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientManagementPage);